// packages
import cx from 'classnames';
import { intcomma } from 'journalize';
import { h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';
import * as d3 from 'd3';

// internal
import { roundThousands } from '../utils/election-utils';
import getJSON from '../utils/get-json';

// components
import EmptyTable from './EmptyTable';

import PureComponent from './PureComponent';

// Mapbox token
let mapboxtoken =
  'pk.eyJ1IjoidGV4YXN0cmlidW5lIiwiYSI6Ilo2eDhZWmcifQ.19qcXfOTN6ulkGW5oouiPQ';

// type Props = {
//   contest: { [key: string]: any };
//   columnCount: number;
//   contestTitle: string;
//   renderParty: any;
//   matchingNote: { [key: string]: any };
//   visibleCandidatesCount?: number;
// };

const converter = PreactHTMLConverter();

class Ballots extends PureComponent {
  constructor() {
    super();
    this.getContainerWidth = this.getContainerWidth.bind(this);
    this.getStaticMap = this.getStaticMap.bind(this);

    this.state = {
      width: null,
      height: 450,
      bodyWidth: null,
      widthMobile: null,
      geometry: null,
      isLoaded: false,
      stats: null,
      simplified_geo: null,
      breakPoint: 544,
    };
  }

  componentDidMount() {
    this.fetchDistrict();
    let { width, bodyWidth, widthMobile } = this.getContainerWidth();

    this.setState({
      width: width,
      bodyWidth: bodyWidth,
      widthMobile: widthMobile,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.contest !== prevProps.contest) {
      this.fetchDistrict();
    }
  }

  fetchDistrict() {
    this.setState({ isLoaded: false });
    const { contest, slug } = this.props;

    // We first get the geometry (borders), stats and simplified geometries (borders for static images) for the previous 2020 districts

    getJSON(
      `${process.env.PUBLIC_PATH}api/${slug}-2020/${contest['key']}.json`
    ).then(geometry => {
      this.setState({
        geometry: geometry,
        isLoaded: true,
        stats: geometry.properties.stats,
        simplified_geo: geometry['geometry_simple'],
      });
    });
  }

  getStaticMap(geometry, point, simplified_geo) {
    let link;

    const { width, bodyWidth, breakPoint, widthMobile } = this.state;

    const bbox = geometry['geometry']['bbox'];

    const geoJSON = encodeURIComponent(JSON.stringify(simplified_geo));

    let imageWidth = bodyWidth < breakPoint ? widthMobile : width;

    link =
      `https://api.mapbox.com/styles/v1/mapbox/light-v10/static/geojson(` +
      geoJSON +
      `),pin-s+000(` +
      point['longitude'] +
      `,` +
      point['latitude'] +
      `)/[` +
      bbox +
      `]/` +
      imageWidth +
      `x` +
      imageWidth +
      `?padding=20&access_token=` +
      mapboxtoken;

    return link;
  }

  getContainerWidth() {
    const base = d3.select('.race');

    const baseMobile = d3.select('.seat__races');

    const body = d3.select('body');

    const width = base.node().offsetWidth;
    const widthMobile = baseMobile.node().offsetWidth;
    const bodyWidth = body.node().offsetWidth;

    return { width, bodyWidth, widthMobile };
  }

  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      matchingNote,
      renderParty,
      slug,
      point,
    } = this.props;

    const { geometry, simplified_geo, isLoaded, stats } = this.state;

    const link = geometry
      ? this.getStaticMap(geometry, point, simplified_geo)
      : null;

    let get_races = contest.values;

    let each_party = get_races.map((candidate: any) => candidate);

    const onePrimary = each_party.length == 1;

    let onePrimaryParty;

    if (onePrimary) {
      onePrimaryParty = each_party[0].values[0].party;
    }

    const IsNoted = matchingNote[0] ? true : false;

    return (
      <div class="seat">
        <h3 class="seat__title">{contestTitle}</h3>

        {isLoaded == true && (
          <div class="district-grid">
            <div
              id={`2020_map-${slug}-district-${contest['key']}`}
              class={`map-chart-container map-chart-container-district-${contest['key']}-2020`}
            >
              <img
                src={link}
                alt={`An image of this district's newly drawn borders`}
                class={`mapbox-image`}
              ></img>
            </div>
            <div class="district-context">
              <p class="district-viewer__copy district-viewer__copytop">
                This district has about{' '}
                <span class="font-weight-bold">
                  {intcomma(roundThousands(stats['CVAP-20152019ACS']))}
                </span>{' '}
                eligible voters according to the latest Census estimates
                available.
              </p>
              <p class="district-viewer__copy">
                Of this group,{' '}
                <span class="font-weight-bold">{`${stats['%AsianAlone'].toFixed(
                  1
                )}%`}</span>{' '}
                are Asian,{' '}
                <span class="font-weight-bold">{`${stats['%BlackAlone'].toFixed(
                  1
                )}%`}</span>{' '}
                are Black,{' '}
                <span class="font-weight-bold">{`${stats['%Hispanic'].toFixed(
                  1
                )}%`}</span>{' '}
                are Hispanic and{' '}
                <span class="font-weight-bold">{`${stats['%WhiteAlone'].toFixed(
                  1
                )}%`}</span>{' '}
                are white.
              </p>
            </div>
          </div>
        )}

        <div class="seat__races">
          {onePrimary && onePrimaryParty == 'Republican' && (
            <EmptyTable party={'Democrat'}/>
       )}
          {each_party.map((party: any) => renderParty(party))}
          {onePrimary && onePrimaryParty == 'Democratic' && (
            <EmptyTable party={'Republican'}/>
       )}
        </div>

        {IsNoted == true && (
          <p class="note__text">{converter.convert(matchingNote[1].value)}</p>
        )}
      </div>
    );
  }
}

export default Ballots;
